module.exports = __webpack_public_path__ + "static/media/corpora_PTT.bc900ae9.jpg";